<template id="boton-proceso-tab-validaciones">
  <div>
    <div class="btn-proceso">
      <v-layout
        class="botones-colores"
        align-center
        justify-center
        fill-height
        wrap
      >
        <v-flex
          xs2
          v-for="(btn, index) in lstBtn"
          :key="index"
          @click="activateBtn(btn)"
        >
          <v-flex botones>
            <mini-statistic
              :icon="btn.icon"
              :title="btn.title"
              :sub-title="btn.subtitle"
              :color="btn.color"
              :class="btn.class"
              :value="true"
            ></mini-statistic>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="tab-validaciones">
      <infraestructura-sub-tab
        v-if="tab == 'Infraestructura'"
      ></infraestructura-sub-tab>
      <rombo-validaciones-sub-tab
        v-if="tab == 'Validaciones'"
        :tabSelected="'Configuración de la jornada'"
      ></rombo-validaciones-sub-tab>
      <administracion-sub-tab
        v-if="tab == 'Administrativo'"
      ></administracion-sub-tab>
      <reportes-sub-tab v-if="tab == 'Productos'"></reportes-sub-tab>
    </div>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic";
import InfraestructuraSubTab from "@/modules/validaciones/views/infraestructura/InfraestructuraSubTab.vue";
import RomboValidacionesSubTab from "@/modules/validaciones/views/romboValidaciones/RomboValidacionesSubTab.vue";
import AdministracionSubTab from "@/modules/adminDocs/views/AdministracionSubTab.vue";
import ReportesSubTab from "@/modules/prodReport/views/ReportesSubTab.vue";

export default {
  name: "boton-proceso-tab-validaciones",
  props: {
    lstBtn: "",
  },
  data() {
    return {
      tab: "Infraestructura",
    };
  },
  components: {
    MiniStatistic,
    InfraestructuraSubTab,
    RomboValidacionesSubTab,
    AdministracionSubTab,
    ReportesSubTab,
  },
  created() {
    this.tab = this.$store.getters.subProTabSelectedStored;
  },

  mounted() {},

  watch: {
    lstBtn(val) {
      //console.log("watch this.subPro:" + this.subPro + ":");
      if (this.lstBtn.length > 0) {
        this.activateBtn(this.lstBtn[0]);
      }
    },
  },

  methods: {
    activateBtn(btn) {
      // console.log("st::detalle:" + JSON.stringify(btn, null, 2));

      this.tab = btn.tab;
      this.$store.commit("sub_tab_state", this.tab);
      this.$store.commit("sub_pro_tab_state", btn.subPro);

      this.lstBtn.forEach((b) => {
        if (b.title != btn.title) {
          //desactiva b: quita "activo" y agrega  elevation-10
          b.class = b.class.replaceAll("activo", "");
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " elevation-10";
          //console.log("desactiva:" + b.title + ":" + b.class + "::");
        } else {
          //activa b:agrega activo, quita  elevation-10
          b.class = b.class.replaceAll("elevation-10", "");
          b.class += " activo";
          //console.log("activa:" + b.title + ":" + b.class + "::");
        }
      });
    },
  },
};
</script>
